import { Link, useLocation } from "react-router-dom";
import VriMark from "@/components/VriMark";

export default function Navbar() {
  const { pathname } = useLocation();
  const link = (to, label, tid) => (
    <Link
      to={to}
      data-testid={tid}
      className={`text-[11px] tracking-[0.18em] uppercase transition-colors whitespace-nowrap ${
        pathname === to ? "text-oxford" : "text-charcoal hover:text-oxford"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="border-b border-oxford/10 bg-linen">
      <nav className="max-w-7xl mx-auto flex items-center justify-between gap-6 px-6 lg:px-12 py-6">
        <Link to="/" data-testid="nav-home-logo" className="flex items-center gap-3 shrink-0">
          <VriMark size={44} className="h-11 w-11 md:h-12 md:w-12" />
          <span className="display-serif text-2xl leading-none">Value Realisation</span>
          <span className="tick-label hidden lg:inline">by Steve Bird</span>
        </Link>
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {link("/framework", "The Framework", "nav-framework")}
          {link("/diagnostic", "The Index", "nav-diagnostic")}
          {link("/benchmark", "Benchmark", "nav-benchmark")}
          {link("/annual-index", "Annual Index", "nav-annual-index")}
          {link("/board/new", "Board Session", "nav-board")}
          {link("/steve", "Steve Bird", "nav-steve")}
        </div>
        <Link to="/diagnostic" data-testid="nav-cta-take-index" className="btn-oxford text-[10px] px-4 py-2 whitespace-nowrap">
          Take the Index
        </Link>
      </nav>
    </header>
  );
}
